import { Box, Grid2, Paper } from '@mui/material';
import React, { Suspense, useEffect, useMemo } from 'react';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { FilterList, SummarizeTwoTone } from '@mui/icons-material';
import Tabla from '../../../../components/ui/materialui/tabla';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import CustomAccordion from '../../../../components/ui/materialui/customAccordion';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import { descargarReporteRecDiaria } from '../../../detalleMutuo/services/servicesReportes';
import { exportExcel } from '../../../../utils/exportExcel';
import { useColumns } from '../utils/columns';
import { useRecaudacionDiaria } from '../hooks/useRecaudacionDiaria';
import { ArgumentosRecDiaria } from '../models/recaudacionDiara';
import * as yup from 'yup'
import { getCurrentUsername } from '../../../../services/userRolesService';

interface FiltroBandeja {
    fechaInicio: Date;
    fechaFin: Date;
    usuario?: string | null;
}

const validationSchema = yup.object().shape({
    fechaInicio: yup
        .date()
        .required('Fecha inicio es requerida'),
    fechaFin: yup
        .date()
        .required('Fecha fin es requerida')        
        .test(
            'fecha-fin-mayor-o-igual',
            'La fecha fin no puede ser menor a la fecha inicio',
            function (value) {
                const { fechaInicio } = this.parent;
                if (!fechaInicio || !value) return true;
                return value >= fechaInicio;
            }
        ),
    usuario: yup
        .string()
        .nullable(),
});

const PageRecaudacionDiaria: React.FC = () => {

    const {
        formState: { errors },
        handleSubmit,
        control,
        watch
    } = useForm<FiltroBandeja>({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
    })
    const {fechaInicio, fechaFin} = watch();
    const COLUMNS = useColumns();
    const columns = useMemo(() => COLUMNS, [COLUMNS]);
    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Reportes', url: `/reportes` },
        { label: 'Recaudación Diaria', active: true },
    ];

    const { fetchData, fetchUsers, user, data } = useRecaudacionDiaria();

    const onSubmit = (data: FiltroBandeja) => {
        fetchData(data.fechaInicio, data.fechaFin, data.usuario ?? '');
    }

    const generar = async () => {
        const args: ArgumentosRecDiaria = {
            lista: data,
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            usuario: getCurrentUsername()
        };
        await descargarReporteRecDiaria(args);
    }

    useEffect(() => {
        fetchUsers();
        // eslint-disable-next-line
    }, [])

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <CustomAccordion
                        title='Filtros'
                        expandedDefault
                    >
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                                <Grid2 size={3}>
                                    <InputFecha
                                        name="fechaInicio"
                                        label="Fecha inicio"
                                        control={control}
                                        error={errors.fechaInicio}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputFecha
                                        name="fechaFin"
                                        control={control}
                                        label="Fecha fin"
                                        error={errors.fechaFin}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        name="usuario"
                                        control={control}
                                        options={user}
                                        label="Usuario"
                                        error={errors.usuario}
                                    />
                                </Grid2>
                                <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                                        Filtrar
                                    </MButton>
                                </Grid2>
                            </Grid2>
                        </form>
                    </CustomAccordion>
                    <Suspense>
                        <Grid2>
                            <Tabla
                                columns={columns}
                                data={data}
                                titulo={<TableHeader
                                    // title="Listado participantes"
                                    buttonExport={
                                        <>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                startIcon={<SummarizeTwoTone />}
                                                // disabled={data.length === 0}
                                                onClick={() => generar()}
                                            // onClick={() => exportExcel(listaParticipantes, columns, "Listado-Participantes")}
                                            >
                                                Generar
                                            </MButton>

                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(data, columns, "Recaudacion-Diaria")}
                                                startIcon={<SummarizeTwoTone />}
                                            >
                                                Exportar
                                            </MButton>
                                        </>
                                    }
                                />}
                            />
                        </Grid2>
                    </Suspense>
                </Paper>
            </Box>
        </Suspense>
    );
};

export default PageRecaudacionDiaria;